module.exports = __webpack_public_path__ + "img/slid_04.a82e2ed8.png";